import { AccountIndicator, Icon } from 'athenaeum';
import noop from 'lodash/noop';
import { useContext } from 'react';
import { createUseStyles } from 'react-jss';

import UserContext from 'contexts/User';

import { useGetHeaderDataQuery } from './graphql/GetHeaderData';
import styles from './styles';
import { PG_PHONE_NUMBER } from '../../constants';

const useStyles = createUseStyles(styles, { name: 'Header' });

const Header = () => {
  const { uuid } = useContext(UserContext);
  const { data } = useGetHeaderDataQuery({
    skip: !uuid,
  });

  const email = data?.currentUser.email ?? '';
  const firstName = data?.currentUser.firstName ?? '';
  const isAccountHolder = !!email;
  const classes = useStyles({ isAccountHolder });

  return (
    <header className={classes.header}>
      <img alt="" className={classes.logo} src="https://static.policygenius.com/logos/pg-lg.svg" />

      <div className={classes.nav}>
        <a className={classes.phoneIcon} href={`tel:${PG_PHONE_NUMBER}`}>
          <Icon
            alt={`Talk with a licensed expert at ${PG_PHONE_NUMBER}`}
            icon="phone"
            height="24px"
            width="24px"
            lazy={false}
          />
        </a>
        <AccountIndicator
          customerName={firstName}
          customerEmail={email}
          dashboardPath={`${process.env.REACT_APP_PG_MONOLITH_HOST}/dashboard`}
          logoutPath={`${process.env.REACT_APP_PG_MONOLITH_HOST}/users/sign_out`}
          isAccountHolder={isAccountHolder}
          onMenuLinkClick={noop}
        />
      </div>
    </header>
  );
};

export default Header;
